// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1H_pZ","header":"MergedInvoice_header__3-JFH"};